<script lang="ts">
import {
  NamedThemeColors,
  type TNamedThemeColorValue,
} from '@goodlifeplus/design-system/theme'
import { type PropType, defineComponent } from 'vue'

/**
 * A simple badge.
 */
export default defineComponent({
  props: {
    size: {
      default: 'sm',
      type: String,
    },
    color: {
      type: String as PropType<TNamedThemeColorValue>,
    },
  },
  setup() {
    return {
      NamedThemeColors,
    }
  },
})
</script>

<template>
  <span
    class="flex h-fit w-fit items-center justify-center whitespace-nowrap rounded-sm py-1 font-bold leading-none"
    :class="{
      'px-1 text-2xs': size === 'sm',
      'px-3 text-xs': size === 'md',
      'bg-purple-200 text-purple-500': color === NamedThemeColors.Primary,
      'text-green-200 bg-green-500': color === NamedThemeColors.Secondary,
      'text-orange-200 bg-orange-500': color === NamedThemeColors.Tertiary,
      'bg-[#E9F5FB] text-[#5F7D92]': color === NamedThemeColors.Neutral,
      'text-black': !color || color === NamedThemeColors.Monochrome,
    }"
  >
    <slot />
  </span>
</template>
